import { getFunctions, httpsCallable } from "firebase/functions";
import { app, auth, ensureAnonAuth } from "../firebase";

const functions = getFunctions(app, "us-central1");

async function withAuth() {
  await ensureAnonAuth();
}

export const api = {
  async createGame() {
    await withAuth();
    const fn = httpsCallable(functions, "createGame");
    const res = await fn({});
    return res.data;
  },
  async joinGame(code) {
    await withAuth();
    const fn = httpsCallable(functions, "joinGame");
    const res = await fn({ code });
    return res.data;
  },
  async joinGameById(gameId) {
    await withAuth();
    const fn = httpsCallable(functions, "joinGameById");
    const res = await fn({ gameId });
    return res.data;
  },
  async signUp(gameId, name) {
    await withAuth();
    const fn = httpsCallable(functions, "signUp");
    const res = await fn({ gameId, name });
    return res.data;
  },
  async updateSelection(gameId, selectedIds) {
    await withAuth();
    const fn = httpsCallable(functions, "updateCharacterSelection");
    const res = await fn({ gameId, selectedIds });
    return res.data;
  },
  async reseedSelection(gameId, roleMap) {
    await withAuth();
    const fn = httpsCallable(functions, "reseedSelection");
    const res = await fn({ gameId, roleMap });
    return res.data;
  },
  async startGame(gameId, roleMap) {
    await withAuth();
    const fn = httpsCallable(functions, "startGame");
    const res = await fn({ gameId, roleMap });
    return res.data;
  },
  async castVote(gameId, targetUid) {
    await withAuth();
    const fn = httpsCallable(functions, "castVote");
    const res = await fn({ gameId, targetUid });
    return res.data;
  },
  async advance(gameId) {
    await withAuth();
    const fn = httpsCallable(functions, "advancePhase");
    const res = await fn({ gameId });
    return res.data;
  },
  async replay(gameId) {
    await withAuth();
    const fn = httpsCallable(functions, "replayGame");
    const res = await fn({ gameId });
    return res.data;
  },
  async readyForReplay(gameId) {
    await withAuth();
    const fn = httpsCallable(functions, "readyForReplay");
    const res = await fn({ gameId });
    return res.data;
  },
  async useAbility(gameId, payload) {
    await withAuth();
    const fn = httpsCallable(functions, "useAbility");
    const res = await fn({ gameId, ...payload });
    return res.data;
  },
  async postVillainChat(gameId, text, nonce) {
    await withAuth();
    const fn = httpsCallable(functions, "postVillainChat");
    const n =
      nonce ||
      `${auth.currentUser?.uid || "u"}_${Date.now()}_${Math.random()
        .toString(36)
        .slice(2, 8)}`;
    const res = await fn({ gameId, text, nonce: n });
    return res.data;
  },
  async postPublicChat(gameId, text, nonce) {
    await withAuth();
    const fn = httpsCallable(functions, "postPublicChat");
    const n =
      nonce ||
      `${auth.currentUser?.uid || "u"}_${Date.now()}_${Math.random()
        .toString(36)
        .slice(2, 8)}`;
    const res = await fn({ gameId, text, nonce: n });
    return res.data;
  },
  async postDeadChat(gameId, text, nonce) {
    await withAuth();
    const fn = httpsCallable(functions, "postDeadChat");
    const n =
      nonce ||
      `${auth.currentUser?.uid || "u"}_${Date.now()}_${Math.random()
        .toString(36)
        .slice(2, 8)}`;
    const res = await fn({ gameId, text, nonce: n });
    return res.data;
  },
  async advancePhase(gameId) {
    await withAuth();
    const fn = httpsCallable(functions, "advancePhase");
    return (await fn({ gameId })).data;
  },
  async forceExpirePhase(gameId) {
    await withAuth();
    const fn = httpsCallable(functions, "forceExpirePhase");
    return (await fn({ gameId })).data;
  },
  async kickPlayer(gameId, playerId) {
    await withAuth();
    const fn = httpsCallable(functions, "kickPlayer");
    await fn({ gameId, playerId });
  },
  async deleteData() {
    await withAuth();
    const fn = httpsCallable(functions, "deleteData");
    const res = await fn({});
    return res.data;
  },
  async setPhaseDurations(gameId, nightSeconds, daySeconds) {
    await withAuth();
    const fn = httpsCallable(functions, "setPhaseDurations");
    const res = await fn({ gameId, nightSeconds, daySeconds });
    return res.data;
  },
  me() {
    return auth.currentUser;
  },
};
